<div class="info-card pt-3 full-width" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
  <div class="full-width" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <mat-icon>description</mat-icon>
      <span class="subtitle-default">Review & Save</span>
    </div>
    <div>
      <app-info-panel
        [message]="['This will save as a planned lease, nothing is finalised yet. You can continue editing the details and move forward when you\'re ready.']"
        [type]="PanelType.INFO"></app-info-panel>
    </div>
  </div>
  <div class="full-width">
    <div class="review-layout">
      <div class="review-section">
        <h3>Tenant Details</h3>
        <div class="detail-item">
          <strong>Name:</strong> {{ bookingConfig.retailerCompanyName }}
        </div>
        <div class="detail-item">
          <strong>Email:</strong> {{ bookingConfig.userEmail }}
        </div>
        <div class="detail-item">
          <strong>Phone:</strong> {{ bookingConfig.userPhoneNumber ?? '-' }}
        </div>
      </div>

      @if (isSubLease) {
        <div class="review-section">
          <h3>Space Details</h3>
          <div class="detail-item">
            <strong>Head Lease:</strong> {{ parentLease?.retailerCompanyName }}
          </div>
          <div class="detail-item">
            <strong>Space:</strong> {{ spaceNames }}
          </div>
          <div class="detail-item">
            <strong>Size:</strong> {{ spaceSize }}m²
          </div>
        </div>
      } @else {
        <div class="review-section">
          <h3>Space Details</h3>
          <div class="detail-item">
            <strong>Space:</strong> {{ spaceNames }}
          </div>
          <div class="detail-item">
            <strong>Location:</strong> {{ spaceLocation }}
          </div>
          <div class="detail-item">
            <strong>Size:</strong> {{ spaceSize }}m²
          </div>
          @if (spaceIndustries.length > 0) {
            <div class="detail-item">
              <strong>Industries:</strong> {{ spaceIndustries }}
            </div>
          }
        </div>
      }

    </div>

    <mat-divider></mat-divider>

    <div class="review-section mt-3 mb-4">
      <h3>Term & Dates</h3>
      <div class="config-layout">
        <div class="config-section">
          <div class="detail-item">
            <strong>Term Type:</strong>
            {{ bookingConfig.bookingType === BookingType.SIMPLE ? 'Simple (All Days)' : 'Complex (Pattern-based)' }}
          </div>
          <div class="detail-item">
            <strong>Lease Term:</strong>
            {{ formatDate(bookingConfig.startDate) }} to {{ formatDate(bookingConfig.endDate) }} ({{ leasePeriodDays }}
            days)
          </div>
        </div>
        <div class="config-section">
          <div class="detail-item">
            <strong>Lease Period:</strong> {{ patternDescription | titlecase }}
          </div>

          <div class="detail-item"
               matTooltip="The number of days the space is actually in use, based on your booking pattern. For example, a 3-month term set to weekends only counts the weekend days, not the full calendar duration.">
            <strong>Occupied Days:</strong> {{ bookingConfig.selectedDates.length }}
          </div>
        </div>
      </div>
    </div>

    <mat-divider></mat-divider>

    <div class="cost-calculation">
      <h3>Final Estimation</h3>
      @if (bookingEstimation) {
        <div class="cost-details">
          <div class="cost-item">
            <span>Effective Spaces:</span>
            <span>{{ bookingEstimation.effectiveSpaces }}</span>
          </div>
          <div class="cost-item">
            <span>Effective space size:</span>
            <span>{{ bookingEstimation.totalSpace }} <span>m<sup>2</sup></span></span>
          </div>
          <div class="cost-item">
            <span>{{ bookingEstimation.periodType | titlecase }} Rate:</span>
            <span>R{{ utils.displayDecimal(bookingEstimation.fixedRate, 2) }}
              @if (bookingEstimation.fixedCategoryType == SpacePricingRateCategory.PER_SQM) {
                <span>/ </span><span>m<sup>2</sup></span>
              }
              </span>
          </div>
          <div class="cost-item">
            <span>Occupied {{ bookingEstimation.periodTypeUnit | titlecase }}s:</span>
            <span>{{ utils.displayDecimal(bookingEstimation.leasePeriods, 1) }} {{ bookingEstimation.periodTypeUnit }}s</span>
          </div>
          <div class="cost-item">
            <span>Lease Duration:</span>
            <span>{{ bookingEstimation.leasePeriodDays }} days</span>
          </div>
          <mat-divider></mat-divider>
          <div class="cost-item total">
            <span>Rent per period:</span>
            <span>R{{ bookingEstimation.rentPerPeriod }} per {{ bookingEstimation.periodTypeUnit }} {{bookingEstimation.variableCost}}</span>
          </div>
          <div class="cost-item">
            <span><strong>Total Estimated Amount:</strong></span>
            <span><strong>R{{ utils.displayDecimal(bookingEstimation.fixedCost, 2) }} {{ bookingEstimation.variableCost }}</strong></span>
          </div>
        </div>
      }
    </div>

    <div class="navigation-buttons">
      <button (click)="prevStep()" class="button-secondary" mat-flat-button>Back</button>
      <button (click)="submitBooking()" [disabled]="!!($loading | async) || submitted" class="button-primary"
              mat-flat-button>
        <div class="button-text">Save Lease</div>
      </button>
    </div>
  </div>
</div>
